import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";

import FnrButton from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";
import { colors } from "UI/colors";

import { useCancelSignupItem } from "./apiHooks";
import { checkForAnyPaidRespondents } from "./utils/checkForAnyPaidRespondents";
import { getUserSignupItem } from "./utils/getUserSignupItem";
import { useIsSignedUpForItem } from "./utils/useIsSignedUpForItem";

CancelMemberSignup.propTypes = {
  signupItemID: PropTypes.number,
  closeItem: PropTypes.func,
};

export default function CancelMemberSignup({ signupItemID, closeItem }) {
  const triggerRef = React.useRef();
  const [state] = useSignups();
  const [isLoading, cancelSignup] = useCancelSignupItem({
    signupItemID,
    closeItem,
  });
  const [showConfirmation, setShowConfirmation] = useState(false);

  const userSignupItem = getUserSignupItem(state.userSignupItems, signupItemID);
  const isSignedUp = useIsSignedUpForItem(signupItemID);
  const hasAnyPaidRespondents = checkForAnyPaidRespondents(userSignupItem);

  const toggleShowConfirmation = () => {
    setShowConfirmation(!showConfirmation);
  };

  const handleCancelClick = () => {
    if (isLoading) return;
    cancelSignup();
  };

  if (!isSignedUp || hasAnyPaidRespondents) return null;

  return (
    <Wrapper>
      <Button role="button" onClick={toggleShowConfirmation} ref={triggerRef}>
        Cancel Signup
      </Button>

      <FnrConfirmationPopover
        show={showConfirmation}
        ref={triggerRef}
        onClose={() => setShowConfirmation(false)}
        message={<div>Are you sure you want to cancel this Signup?</div>}
        button1={
          <FnrButton
            text="Yes, cancel it!"
            onClick={handleCancelClick}
            color="red"
            loading={isLoading}
          />
        }
        color="red"
        style={{ maxWidth: 200, padding: 10 }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 5px;
`;

const Button = styled.div`
  background-color: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: #c72323;
  font-weight: 400;
  transition: color 200ms;

  &:hover {
    color: ${colors.fnRed};
  }
  &:active {
    transform: scale(0.97);
  }
`;
